import * as _ from 'lodash'
import {
    IBusinessObject,
    IBusinessObjectChanges,
    IBusinessObjectChangesOptions,
    IBusinessObjectCreateLoadOptions
} from "../PA.Core/PA.Core.IF.BO";
import { IEntitySource, IMessageProvider, IProgressProvider, MessageType } from "../PA.Core/PA.Core.IF.Basic";
import { PAdbContext } from '../PA.Core/PAdbContext';
import { IdentityProvider } from '../PA.Core/Basic/Identity'
import { MessageProvider } from '../PA.Core/Basic/Messages'
import { ProgressProvider } from '../PA.Core/Basic/Progress'
import {
    WB_CustomerRow,
    WB_FinishedProductRow,
    WB_ProductGroupRow,
    WB_Published_ModelRow, WB_ScenarioConstraintRow, WB_ScenarioPlannerConstraintRow,
    WB_ScenarioPlannerCustomerRow,
    WB_ScenarioPlannerEventTypeRow,
    WB_ScenarioPlannerProductPartitionRelRow,
    WB_ScenarioPlannerProductPartitionRow,
    WB_ScenarioPlannerProductRow,
    WB_ScenarioPlannerRow,
    WB_ScenarioPlanRow
} from "../PA.Core/PAdbSchemaRows";
import { IwbScenarioPlan } from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Customer,
    esWB_Entity,
    esWB_MasterData_Set,
    esWB_Model,
    esWB_Product_Group,
    esWB_Published_Model,
    esWB_SalesOrg, esWB_ScnConstraint,
    esWB_ScnPlan,
    esWB_ScnPlanner,
    esWB_ScnPlannerCalc,
    esWB_ScnPlannerCnstr,
    esWB_ScnPlannerCR,
    esWB_ScnPlannerESR,
    esWB_ScnPlannerPPR,
    esWB_ScnPlannerPR,
    esWB_ScnPlannerPrdPPR,
    esWB_ScnPlannerPrdPR,
    esWB_ScnPlannerTrial,
    esWB_ScnPlannerTrialCNR,
    esWB_ScnPlannerTrialEvt,
    esWB_ScnPlannerTrialPR
} from "../PA.Core/PAdbSchema";
import { ESRecord } from "../PA.Core/lib/ESRecord";
import { ESDataStore } from "../PA.Core/lib/ESDataStore";
import { CreateOptions, ESRecordResolver } from "../PA.Core/lib/ESRecordResolver";
import { ASync } from "../PA.Core/Basic/ASync";

import { PAEnvironment } from "../PA.Core/PAEnvironment";
import { DefaultChanges } from "../PA.Core/BusinessObject/BusinessObjectChanges";
import { BehaviorSubject } from "rxjs";
import { CoefficientSetUtils, ICoefficientSetSubModel } from "../PA.Model.Core/CoefficientSetUtils";
import { EntityTypeUtils } from "../PA.MD.Entity/EntityTypeUtils";
import { DateUtils } from "../PA.Core/Basic/Dates";
import { IPolicyCollection } from "../PA.Core/PA.Core.IF.Policy";
import { IHaveSecurity } from "../PA.Core/PA.Core.IF.Aspects";
import { PolicyHasRole } from "../PA.Core/Security/PolicyHasRole";
import { PolicyBOis } from "../PA.Core/Security/PolicyBOis";
import { PolicyCollection } from "../PA.Core/Security/PolicyCollection"
import { ErrorMessage_restate, InfoMessage_restate } from "../PA.Core/Basic/MessageUtils";

//const arrSIMULATION_INPUT_IDs = ['GROSSLISTPRICE', 'LISTPRICE', 'VCM', 'COGS']
//const arrSIMULATION_INPUT_TYPE_IDs = ['GrossListPrice', 'ListPrice', 'VCM', 'COGS']
const sleep = (ms: number) =>
    new Promise(resolve => setTimeout(resolve, ms));


export class ScenarioPlannerBO
    implements
        IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: IBusinessObjectCreateLoadOptions;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_ScenarioPlanner: WB_ScenarioPlannerRow;


    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({ id: 0, name: 'New Scenario' });

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_ScenarioPlanner = undefined;

        this.IHaveSecurity_init();
        this.IScenarioPlanner_Scenario_Scope_init();
        this.IScenarioPlanner_Scope_init();
        this.IScenarioPlanner_TrialStructure_init();
        this.IScenarioPlanner_Partitions_init();
        this.IScenarioPlanner_Constraints_init();
        this.CustomerProducts_init();

    }


    get WB_ScenarioPlanner(): WB_ScenarioPlannerRow {
        return this.drWB_ScenarioPlanner;
    }

    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: IBusinessObjectCreateLoadOptions): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Scenario Planner");
        const rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for new Scenario Planner.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }
            try {
                // Create record using dbContext
                const plannerRow: WB_ScenarioPlannerRow = <WB_ScenarioPlannerRow>await self.dbContext.createRecordWithKey(esWB_ScnPlanner)
                plannerRow.setDefaults()
                plannerRow.cif.PLANNER_NAME = self.LoadOptions.sName
                plannerRow.cif.WB_MDSET_ID = self.LoadOptions.wbMasterDataSetId || 0
                plannerRow.cif.WB_SALESORG_ID = self.LoadOptions.wbSalesOrgId || 0
                plannerRow.cif.WB_PUBLISHED_MODEL_ID = self.LoadOptions.wbPublishedModelId || 0

                await plannerRow.loadRelations([esWB_Published_Model, esWB_MasterData_Set, esWB_SalesOrg])
                if(!_.isEmpty(plannerRow.WB_PublishedModelRow)) {
                    await plannerRow.WB_PublishedModelRow.loadRelations([esWB_Model])
                    plannerRow.StartDt = plannerRow.WB_PublishedModelRow.EffectiveStartDt
                    plannerRow.EndDt = DateUtils.addDays(plannerRow.StartDt,6)

                }

                self.drWB_ScenarioPlanner = plannerRow;
                self.dbContext.add(esWB_ScnPlanner, plannerRow)
                self.Identity.setAll(self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID, self.WB_ScenarioPlanner.cif.PLANNER_ID, self.WB_ScenarioPlanner.cif.PLANNER_NAME);
                self.Identity.listenToRecordUpdates(self.WB_ScenarioPlanner, "WB_SCNPLANNER_ID", "PLANNER_ID", "PLANNER_NAME");
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlanner, "PLANNER_ID", "PLANNER_NAME");
                self.Identity.mdset = self.WB_ScenarioPlanner.cif.WB_MDSET_ID;
                self.Identity.salesOrg = self.WB_ScenarioPlanner.cif.WB_SALESORG_ID;
                self.Identity.createdBy = self.WB_ScenarioPlanner.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();

                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number , options?: object): Promise<IBusinessObject> {
        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        const rv = self._OnLoadComplete = (async () => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Scenario Plan already loaded.");
                self._OnLoadComplete = undefined;
                return self;
            }

            self.LoadOptions = options || {};

            try {
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({});
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception("Unable to determine dbContext for Scenario Plan.");
                    return self;
                }


                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = ScenarioPlannerBO.createRecordResolver({ dbContext: self.dbContext })
                    recordResolverLoadPromise = ScenarioPlannerBO.setupRecordResolver(recordResolver, [anId])
                }


                await recordResolverLoadPromise
                const aPlanRow: any = recordResolver.get(esWB_ScnPlanner, anId)

                if (_.isEmpty(aPlanRow)) {
                    throw "Scenario Planner not found";
                }

                self.drWB_ScenarioPlanner = aPlanRow;
                self.Identity.setAll(self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID, self.WB_ScenarioPlanner.cif.PLANNER_ID, self.WB_ScenarioPlanner.cif.PLANNER_NAME)
                self.Identity.listenToRecordUpdates(self.WB_ScenarioPlanner, 'WB_SCNPLANNER_ID', 'PLANNER_ID', 'PLANNER_NAME')
                self.Identity.enableRecordWriteBack(self.WB_ScenarioPlanner, "PLANNER_ID", "PLANNER_NAME")
                self.Identity.mdset = self.WB_ScenarioPlanner.cif.WB_MDSET_ID;
                self.Identity.salesOrg = self.WB_ScenarioPlanner.cif.WB_SALESORG_ID;
                self.Identity.createdBy = self.WB_ScenarioPlanner.cif.WB_AUTHUSR_ID_CREATEDBY

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();

                return self;
            } catch
                (err) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                throw err
            }

        })();

        return rv;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {
        const self = this;

        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_ScenarioPlanner.cif.MDSET_NAME + "(" + self.WB_ScenarioPlanner.cif.MDSET_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                const sError = "Unable to determine dbContext for to Validate Scenario Planner.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self.ValidateMessageProvider.addMessage({
                code: 'Exception',
                type: MessageType.Error,
                description: JSON.stringify(err),
                title: 'Validation Exception'
            })
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        self._bIsSaved = false
        const wbScenarioPlan = <IwbScenarioPlan>self.drWB_ScenarioPlanner;
        self.SaveProgressProvider.start("Saving " + wbScenarioPlan.PLAN_NAME + "(" + wbScenarioPlan.PLAN_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                const sError = "Unable to determine dbContext to Save Scenario Plan.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if (self.ValidateMessageProvider.countMessages(MessageType.Error) > 0) {
                self.SaveProgressProvider.finish();
                return self
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_ScnPlanner, self.drWB_ScenarioPlanner, {})

            const tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_ScnPlannerESR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerEventTypeRows))
            tasks.push(saveFunction(esWB_ScnPlannerCR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows))
            tasks.push(saveFunction(esWB_ScnPlannerPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductRows))
            tasks.push(saveFunction(esWB_ScnPlannerPPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerPeriodPartitionRows))
            tasks.push(saveFunction(esWB_ScnPlannerPrdPR, self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows))
            tasks.push(saveFunction(esWB_ScnPlannerPrdPPR, _.flatMap(self.drWB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows, (a) => a.WB_ScenarioPlannerProductPartitionRelRows)))
            tasks.push(saveFunction(esWB_ScnPlannerCnstr, self.drWB_ScenarioPlanner.WB_ScenarioPlannerConstraintRows))
            tasks.push(saveFunction(esWB_ScnPlannerTrial, self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows))
            tasks.push(saveFunction(esWB_ScnPlannerTrialPR, _.flatMap(self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows, (a) => a.WB_ScenarioPlannerTrialPRRows)))
            tasks.push(saveFunction(esWB_ScnPlannerTrialCNR, _.flatMap(self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialRows, (a) => a.WB_ScenarioPlannerTrialCNRRows)))
            tasks.push(saveFunction(esWB_ScnPlannerTrialEvt, self.drWB_ScenarioPlanner.WB_ScenarioPlannerTrialEventRows))
            await Promise.all(tasks)


            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;

        const scnPlan = <IwbScenarioPlan>self.drWB_ScenarioPlanner;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + scnPlan.PLAN_NAME + "(" + scnPlan.PLAN_ID + ")");

        try {
            // 1. Validate if we can delete the Scenario
            //await ScenarioPlanBOValidations.ValidateDelete(self)
            if (self.DeleteMessageProvider.countMessages(MessageType.Error) > 0) {
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_ScenarioPlanner.markDeleted()

            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return (self);
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;
            }

        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;

        self.LoadProgressProvider.setProgressMessage('ScenarioPlannerBO.PostLoad', 'Processing Loaded Data');

        await self.IHaveSecurity_OnLoadComplete()

        const tasks: Promise<any>[] = [];
        tasks.push(self.CustomerProducts_OnLoadComplete())

        await Promise.all(tasks)

        return
    }


    //</editor-fold>

    //<editor-fold desc = "IHaveSecurity operations">

    private _PolicyCollection: IPolicyCollection;
    private _bIHaveSecurityLoaded: boolean;
    private _OnIHaveSecurityLoaded: Promise<IHaveSecurity>

    //private _Lock: ILock

    IHaveSecurity_init() {
        this._PolicyCollection = new PolicyCollection()
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
        //this._Lock = undefined
    }

    IHaveSecurity_beforeReload() {
        this._bIHaveSecurityLoaded = false
        this._OnIHaveSecurityLoaded = undefined
    }

    IHaveSecurity_OnLoadComplete(): Promise<void> {
        const self = this

        return new Promise<void>((resolve, error) => {
            self.OnIHaveSecurityLoaded
                .then((ignore) => {
                    resolve()
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

    get OnIHaveSecurityLoaded(): Promise<IHaveSecurity> {
        const self = this

        if (this.bIHaveSecurityLoaded) {
            return ASync.resolve(this)
        }

        if (this._OnIHaveSecurityLoaded) {
            return this._OnIHaveSecurityLoaded
        }

        let aHasRolePolicy: PolicyHasRole;
        this._OnIHaveSecurityLoaded = (async () => {
            const aBOis = new PolicyBOis(["Super_User", "Application_User"], []);
            self._PolicyCollection.addPolicy("BOis", aBOis);
            aHasRolePolicy = new PolicyHasRole();
            await aHasRolePolicy.OnLoadComplete;
            self._PolicyCollection.addPolicy("HasRole", aHasRolePolicy);
            this._bIHaveSecurityLoaded = true;
            return self;
        })();

        return this._OnIHaveSecurityLoaded
    }

    get PolicyCollection(): IPolicyCollection {
        return this._PolicyCollection
    }

    get bIHaveSecurityLoaded(): boolean {
        return this._bIHaveSecurityLoaded
    }


//</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        const opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_ScenarioPlanner, opts)
    }


    //</editor-fold>

    //<editor-fold desc = "Add Remove Customer, Product operations">

    private _bHasProductGroups: boolean
    private _bHasProducts: boolean
    private _allCustomers: WB_CustomerRow[]
    private _allProductGroups: WB_ProductGroupRow[]
    private _allProducts: WB_FinishedProductRow[]
    private _subModels: ICoefficientSetSubModel[]
    private _onCustomersChanged: BehaviorSubject<ScenarioPlannerBO>
    private _onProductsChanged: BehaviorSubject<ScenarioPlannerBO>
    private custEntitySource: IEntitySource
    private prdEntitySource: IEntitySource
    private wbPublishedModelId_Loaded: number

    private CustomerProducts_init() {
        this._bHasProductGroups = false
        this._bHasProducts = false
        this._allCustomers = []
        this._allProductGroups = []
        this._allProducts = []
        this._onCustomersChanged = new BehaviorSubject<ScenarioPlannerBO>(undefined)
        this._onProductsChanged = new BehaviorSubject<ScenarioPlannerBO>(undefined)
        this._subModels = []
        this.wbPublishedModelId_Loaded = 0
    }

    private async CustomerProducts_OnLoadComplete(): Promise<void> {
        const self = this
        await self.CustomerProducts_checkPublishedModelComponents()
    }

    private async CustomerProducts_checkPublishedModelComponents(): Promise<void> {
        const self = this

        //
        if (_.isEmpty(this.WB_ScenarioPlanner?.WB_PublishedModelRow)) {
            // Reset things
            return
        }

        // Check if we already loaded this published model
        if(this.wbPublishedModelId_Loaded == this.WB_ScenarioPlanner?.WB_PublishedModelRow.cif.WB_PUBLISHED_MODEL_ID)
            return

        this.wbPublishedModelId_Loaded = this.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_PUBLISHED_MODEL_ID


        const prdEntity = await EntityTypeUtils.getEntityTypeRow(this.WB_ScenarioPlanner.WB_PublishedModelRow.cif.WB_ENTITY_ID_PRODUCT)

        if (_.isEmpty(prdEntity))
            return

        this._bHasProducts = (prdEntity.cif.ENTITY_ID in { FinishedProduct: 0, ConsumerProduct: 1 })
        this._bHasProductGroups = !this._bHasProducts

        const wbCoefSetId = this.WB_ScenarioPlanner.WB_PublishedModelRow?.cif?.WB_MODEL_COEFF_SET_ID

        const a = await CoefficientSetUtils.getCoefficientSetMasterData(wbCoefSetId, this.dbContext, true)
        this._allCustomers = a.Customers || []
        this._allProducts = a.Products || []
        this._allProductGroups = a.ProductGroups || []
        this._subModels = a.SubModels

        this.custEntitySource = {
            get Entities() {
                return self.AllCustomers
            },
            get Selected() {
                return self.Customers
            },
            keyFields: {
                id: 'WB_CUST_ID',
                id_ui: 'CUSTOMER_ID',
                name: 'CUSTOMER_NAME'
            },
            onChange: this.OnCustomersChanged,
            addSelection(id: number): Promise<void> {
                return <any>self.addCustomer(id)
            },
            removeSelection(id: number): Promise<void> {
                return self.removeCustomer(id)
            }

        }


        if (this._bHasProductGroups) {
            this.prdEntitySource = {
                get Entities() {
                    return self.AllProductGroups
                },
                get Selected() {
                    return self.ProductGroups
                },
                keyFields: {
                    id: 'WB_PRDGRP_ID',
                    id_ui: 'PRODUCT_GROUP_ID',
                    name: 'PRODUCT_GROUP_NAME'
                },
                onChange: this.OnProductsChanged,
                addSelection(id: number): Promise<void> {
                    return <any>self.addProductGroup(id)
                },
                removeSelection(id: number): Promise<void> {
                    return self.removeProductGroup(id)
                }
            }
        }

    }

    get OnCustomersChanged(): BehaviorSubject<ScenarioPlannerBO> {
        return this._onCustomersChanged
    }

    get OnProductsChanged(): BehaviorSubject<ScenarioPlannerBO> {
        return this._onProductsChanged
    }

    get AllCustomers(): WB_CustomerRow[] {
        return this._allCustomers
    }

    get Customers(): WB_CustomerRow[] {
        return _.map(_.filter(this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_CustomerRow)
            }),
            (b) => b.WB_CustomerRow)
    }


    get AllProductGroups(): WB_ProductGroupRow[] {
        return this._allProductGroups
    }

    get ProductGroups(): WB_ProductGroupRow[] {
        return _.map(_.filter(this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows, (a) => {
                return a.isActive && !_.isEmpty(a.WB_ProductGroupRow) && (a.cif.WB_PRDGRP_ID > 0)
            }),
            (b) => b.WB_ProductGroupRow)
    }

    get CustomerEntitySource(): IEntitySource {
        return this.custEntitySource
    }

    get ProductEntitySource(): IEntitySource {
        return this.prdEntitySource
    }

    async addCustomer(wbCustId: number): Promise<WB_ScenarioPlannerCustomerRow> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                return a;
        }

        const cust = <WB_CustomerRow>await self.dbContext.find(esWB_Customer, wbCustId);
        if (_.isEmpty(cust))
            return undefined;

        const newRow = <WB_ScenarioPlannerCustomerRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerCR);
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID;
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner;
        newRow.cif.WB_CUST_ID = wbCustId;
        newRow.WB_CustomerRow = cust;
        self.dbContext.add(esWB_ScnPlannerCR, newRow)
        self.OnCustomersChanged.next(self)
        return newRow;
    }

    async removeCustomer(wbCustId: number): Promise<void> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerCustomerRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_CUST_ID == wbCustId)
                a.markDeleted();
        }
        self.OnCustomersChanged.next(self)
    }

    async addProductGroup(wbPrdGrpId: number): Promise<WB_ScenarioPlannerProductRow> {
        const self = this;
        //--
        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                return a;
        }

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId);
        if (_.isEmpty(pg))
            return undefined;

        const newRow = <WB_ScenarioPlannerProductRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerPR);
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID;
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner;
        newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
        newRow.WB_ProductGroupRow = pg;
        self.dbContext.add(esWB_ScnPlannerPR, newRow)
        self.OnProductsChanged.next(self)

        return newRow;
    }

    async removeProductGroup(wbPrdGrpId: number): Promise<void> {
        const self = this;
        //--
        if (!(wbPrdGrpId > 0))
            return

        for (const a of this.WB_ScenarioPlanner.WB_ScenarioPlannerProductRows) {
            if (!a.isActive)
                continue;
            if (a.cif.WB_PRDGRP_ID == wbPrdGrpId)
                a.markDeleted();
        }
        self.OnProductsChanged.next(self)

    }


    //</editor-fold>


    //<editor-fold desc = "IScenarioPlanner Scenario Scope operations">

    private _onScenarioScopeLockChange: BehaviorSubject<void>
    private _scenarioMessages: MessageProvider
    private _scenarioProgress: ProgressProvider

    private IScenarioPlanner_Scenario_Scope_init() {
        //--
        this._onScenarioScopeLockChange = new BehaviorSubject<void>(undefined)
        this._scenarioMessages = new MessageProvider()
        this._scenarioProgress = new ProgressProvider()
    }

    get OnScenarioScopeLockChanged(): BehaviorSubject<void> {
        return this._onScenarioScopeLockChange
    }

    get bScenarioLocked(): boolean {
        return this.WB_ScenarioPlanner.bScenarioLocked
    }

    set bScenarioLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }

    get ScenarioMessages(): MessageProvider {
        return this._scenarioMessages;
    }

    get ScenarioProgress(): ProgressProvider {
        return this._scenarioProgress;
    }

    async unlockScenario(): Promise<void> {
        //
        let mp = this._scenarioMessages
        let pp = this._scenarioProgress
        pp.start()
        mp.clearMessages()

        // Validate if you can unlock



        InfoMessage_restate(mp, true, "Unlocked", "Scenario Unlocked")
        this.WB_ScenarioPlanner.bScenarioLocked = false
        this._onScenarioScopeLockChange.next()
        pp.finish()
    }

    async validateAndLockScenario(): Promise<void> {
        // Load Published Model, etc, etc
        //--
        let mp = this._scenarioMessages
        let pp = this._scenarioProgress
        pp.start()
        mp.clearMessages()

        if(!(this.WB_ScenarioPlanner.cif.WB_SCNPLAN_ID > 0)){
            ErrorMessage_restate(mp, true, "Not Set", "Scenario Plan not set")
            pp.finish()
            return
        }

        // Load Scenario
        await this.loadScenario(mp)

        InfoMessage_restate(mp, true, "Locked", "Scenario Locked")
        this.WB_ScenarioPlanner.bScenarioLocked = true
        this._onScenarioScopeLockChange.next()
        pp.finish()
    }

    private async loadScenario(mp: MessageProvider): Promise<void> {
        const self = this
        const scnPlnrRow = self.WB_ScenarioPlanner
        const scnPlnr = self.WB_ScenarioPlanner.cif

        if(!(scnPlnr.WB_SCNPLAN_ID > 0)){
            ErrorMessage_restate(mp, true, "Not Set", "Scenario Plan not set")
            return
        }

        let scnPlanRow = <WB_ScenarioPlanRow> await self.dbContext.find(esWB_ScnPlan, scnPlnr.WB_SCNPLAN_ID)

        if(_.isEmpty(scnPlanRow) || !scnPlanRow?.isActive){
            ErrorMessage_restate(mp, true, "Not Set", `Scenario Plan (${scnPlnr.WB_SCNPLAN_ID}) not found`)
            return
        }

        await scnPlanRow.loadRelations([esWB_Published_Model])
        let pblshModelRow = <WB_Published_ModelRow> scnPlanRow.WB_PublishedModelRow

        if(_.isEmpty(pblshModelRow) || !pblshModelRow?.isActive){
            ErrorMessage_restate(mp, true, "Not Set", `Published Model (${scnPlanRow.cif.WB_PUBLISHED_MODEL_ID}) not found`)
            return
        }

        scnPlnrRow.cif.WB_PUBLISHED_MODEL_ID = pblshModelRow.cif.WB_PUBLISHED_MODEL_ID
        scnPlnrRow.WB_PublishedModelRow = pblshModelRow

        if(_.isEmpty(scnPlnr.PERIODPART_START_DT) && _.isEmpty(scnPlnr.PERIODPART_END_DT)){
            scnPlnrRow.StartDt = scnPlanRow.StartDt
            scnPlnrRow.EndDt = scnPlanRow.EndDt
        }

        // Load Customer, Products
        await self.CustomerProducts_checkPublishedModelComponents()

    }

    //</editor-fold>


    //<editor-fold desc = "IScenarioPlanner Scope operations">

    private _onScopeLockChange: BehaviorSubject<void>
    private _scopeMessages: MessageProvider
    private _scopeProgress: ProgressProvider

    private IScenarioPlanner_Scope_init() {
        //--
        this._onScopeLockChange = new BehaviorSubject<void>(undefined)
        this._scopeMessages = new MessageProvider()
        this._scopeProgress = new ProgressProvider()

    }

    get OnScopeLockChanged(): BehaviorSubject<void> {
        return this._onScopeLockChange
    }

    get ScopeMessages(): MessageProvider {
        return this._scopeMessages;
    }

    get ScopeProgress(): ProgressProvider {
        return this._scopeProgress;
    }


    get bScopeLocked(): boolean {
        return this.WB_ScenarioPlanner.bLocked
    }

    set bScopeLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }


    async unlockScope(): Promise<void> {
        //

        this.WB_ScenarioPlanner.bLocked = false
        this._onScopeLockChange.next()
    }

    async validateAndLockScope(): Promise<void> {
        let mp = this._scopeMessages
        let pp = this._scopeProgress
        pp.start()
        mp.clearMessages()


        // Validate selections

        ErrorMessage_restate(mp, !this.bScenarioLocked,
            "Not Set", "Scenario Plan not locked")

        ErrorMessage_restate(mp, !(this.WB_ScenarioPlanner.cif.WB_MODEL_EVTTYPER_ID > 0),
            "EvtTypeNotSet","Event Type not set")

        ErrorMessage_restate(mp, !(this.Customers.length),
            "NoCusts", "No Customers Selected")

        ErrorMessage_restate(mp, !(this.ProductGroups.length),
            "NoProducts", "No Products Selected")

        ErrorMessage_restate(mp, !_.isDate(this.WB_ScenarioPlanner.StartDt),
            "StartDtInvalid", "Start Date is not set")

        ErrorMessage_restate(mp, !_.isDate(this.WB_ScenarioPlanner.EndDt),
            "EndDtInvalid", "End Date is not set")

        ErrorMessage_restate(mp, !DateUtils.isLessThanEqual(this.WB_ScenarioPlanner.StartDt, this.WB_ScenarioPlanner.EndDt),
            "InvalidDate", "Invalid Date Range")

        if(mp.countMessages(MessageType.Error) > 0){
            pp.finish()
            return
        }

        this.WB_ScenarioPlanner.bLocked = true
        this._onScopeLockChange.next()
        pp.finish()
    }

    //</editor-fold>

    //<editor-fold desc = "IScenarioPlanner Product/Partition operations">

    private _onProductPartitionsChange: BehaviorSubject<void>
    private _onEvtSubTypeChange: BehaviorSubject<void>

    private IScenarioPlanner_Partitions_init() {
        //--
        this._onProductPartitionsChange = new BehaviorSubject<void>(undefined)
        this._onEvtSubTypeChange = new BehaviorSubject<void>(undefined)

    }

    get OnProductPartitionsChanged(): BehaviorSubject<void> {
        return this._onProductPartitionsChange
    }

    get OnEventSubTypesChanged(): BehaviorSubject<void> {
        return this._onEvtSubTypeChange
    }

    async addPartition(sName: string): Promise<WB_ScenarioPlannerProductPartitionRow> {
        const self = this;

        const newRow = <WB_ScenarioPlannerProductPartitionRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerPrdPR);
        newRow.setDefaults()
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID;
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner;
        newRow.cif.PRODUCT_PARTITION_NAME = sName
        self.dbContext.add(esWB_ScnPlannerPrdPR, newRow)
        self.OnProductPartitionsChanged.next()
        return newRow;

    }

    async removePartition(wbScnPlannerPrdPRId: number): Promise<void> {
        const self = this;
        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows, (ppr) => {
            if(!ppr.isActive)
                return

            if(ppr.cif.WB_SCNPLANNERPRDPR_ID == wbScnPlannerPrdPRId){
                _.forEach(ppr.WB_ScenarioPlannerProductPartitionRelRows, (r) => {
                    if(r.isActive)
                        r.markDeleted()
                })
                ppr.markDeleted()
            }

        })
        self.OnProductPartitionsChanged.next()
    }

    async addPartitionProductGroup(wbScnPlannerPrdPRId: number, wbPrdGrpId: number): Promise<WB_ScenarioPlannerProductPartitionRelRow> {
        const self = this;

        const pg = <WB_ProductGroupRow>await self.dbContext.find(esWB_Product_Group, wbPrdGrpId);
        if (_.isEmpty(pg))
            return undefined;

        for(let ppr of self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows){
            if (!ppr.isActive)
                continue

            if(ppr.cif.WB_SCNPLANNERPRDPR_ID != wbScnPlannerPrdPRId)
                continue

            for(let prdr of ppr.WB_ScenarioPlannerProductPartitionRelRows){
                if(!prdr.isActive)
                    continue

                if (prdr.cif.WB_PRDGRP_ID == wbPrdGrpId)
                    return prdr
            }

            // Not found, create record
            const newRow = <WB_ScenarioPlannerProductPartitionRelRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerPrdPPR);
            newRow.cif.WB_SCNPLANNERPRDPR_ID = ppr.cif.WB_SCNPLANNERPRDPR_ID;
            newRow.WB_ScenarioPlannerProductPartitionRow = ppr
            newRow.cif.WB_PRDGRP_ID = wbPrdGrpId;
            newRow.WB_ProductGroupRow = pg;
            self.dbContext.add(esWB_ScnPlannerPrdPPR, newRow)
            self.OnProductPartitionsChanged.next()
            return newRow;

        }
        return undefined
    }

    async removePartitionProductGroup(wbScnPlannerPrdPPRId: number): Promise<void> {
        const self = this;

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerProductPartitionRows, (ppr) => {
            if(!ppr.isActive)
                return

                _.forEach(ppr.WB_ScenarioPlannerProductPartitionRelRows, (r) => {
                    if(!r.isActive)
                        return

                    if(r.cif.WB_SCNPLANNERPRDPPR_ID == wbScnPlannerPrdPPRId)
                        r.markDeleted()
                })

        })
        self.OnProductPartitionsChanged.next()

    }

    async addEventSubType(): Promise<WB_ScenarioPlannerEventTypeRow> {
        const self = this;
        //--

        const newRow = <WB_ScenarioPlannerEventTypeRow>await self.dbContext.createRecordWithKey(esWB_ScnPlannerESR);
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID;
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner;
        self.dbContext.add(esWB_ScnPlannerESR, newRow)
        self.OnEventSubTypesChanged.next()

        return newRow;
    }

    async removeEventSubType(wbScnPlannerESRId: number): Promise<void> {
        const self = this;

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerEventTypeRows, (est) => {
            if(!est.isActive)
                return
            if(est.cif.WB_SCNPLANNERESR_ID == wbScnPlannerESRId){
                est.markDeleted()
            }
        })

        self.OnEventSubTypesChanged.next()
    }



    //</editor-fold>


    //<editor-fold desc = "IScenarioPlanner Product/Partition operations">

    private _onConstraintsChanged: BehaviorSubject<void>


    private IScenarioPlanner_Constraints_init() {
        //--
        this._onConstraintsChanged = new BehaviorSubject<void>(undefined)
    }

    get OnConstraintsChanged(): BehaviorSubject<void> {
        return this._onConstraintsChanged
    }

    async addConstraint(wbScnConstraintMId: number): Promise<WB_ScenarioPlannerConstraintRow> {
        const self = this;

        const cnst = <WB_ScenarioConstraintRow>await self.dbContext.find(esWB_ScnConstraint, wbScnConstraintMId);
        if (_.isEmpty(cnst))
            return undefined;

        // Not found, create record
        const newRow = <WB_ScenarioPlannerConstraintRow> await self.dbContext.createRecordWithKey(esWB_ScnPlannerCnstr);
        newRow.cif.WB_SCNPLANNER_ID = self.WB_ScenarioPlanner.cif.WB_SCNPLANNER_ID
        newRow.WB_ScenarioPlannerRow = self.WB_ScenarioPlanner
        newRow.cif.WB_SCNCONSTRAINTM_ID = wbScnConstraintMId;
        newRow.WB_ScenarioConstraintRow = cnst;
        self.dbContext.add(esWB_ScnPlannerCnstr, newRow)
        self.OnConstraintsChanged.next()
        return newRow;
    }

    async removeConstraint(wbScnPlannerCnstRId: number): Promise<void> {
        const self = this;

        _.forEach(self.WB_ScenarioPlanner.WB_ScenarioPlannerConstraintRows, (cnstr) => {
            if(!cnstr.isActive)
                return
            if(cnstr.cif.WB_SCNPLANNERCNSTR_ID == wbScnPlannerCnstRId){
                cnstr.markDeleted()
            }
        })

        self.OnConstraintsChanged.next()
    }

    //</editor-fold>


    //<editor-fold desc = "IScenarioPlanner Scope operations">

    private _onTrialStructureLockChange: BehaviorSubject<void>
    private _trialStructureMessages: MessageProvider
    private _trialStructureProgress: ProgressProvider

    private IScenarioPlanner_TrialStructure_init() {
        //--
        this._onTrialStructureLockChange = new BehaviorSubject<void>(undefined)
        this._trialStructureMessages = new MessageProvider()
        this._trialStructureProgress = new ProgressProvider()

    }

    get OnTrialStructureLockChanged(): BehaviorSubject<void> {
        return this._onTrialStructureLockChange
    }

    get TrialStructureMessages(): MessageProvider {
        return this._scopeMessages;
    }

    get TrialStructureProgress(): ProgressProvider {
        return this._scopeProgress;
    }

    get bTrialStructureLocked(): boolean {
        return this.WB_ScenarioPlanner.bTrialStructureLocked
    }

    set bTrialStructureLocked(val: boolean) {
        // Don't do anything, use workflow to lock
    }


    async unlockTrialStructure(): Promise<void> {
        //

        this.WB_ScenarioPlanner.bTrialStructureLocked = false
        this._onTrialStructureLockChange.next()
    }

    async validateAndLockTrialStructure(): Promise<void> {
        let mp = this._trialStructureMessages
        let pp = this._trialStructureProgress
        pp.start()
        mp.clearMessages()

        // Validate selections

        //--

        this.WB_ScenarioPlanner.bTrialStructureLocked = true
        this._onTrialStructureLockChange.next()
        pp.finish()
    }

    //</editor-fold>



    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        const opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const scope_options: CreateOptions = {
            standardConditions: {
                [esWB_ScnPlanner]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerCR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerPR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerCnstr]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerPPR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerPrdPR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerPrdPPR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerESR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerTrial]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerTrialCNR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerTrialPR]: { "DELETED_IND": { "notIn": ['1'] } },
                [esWB_ScnPlannerTrialEvt]: { "DELETED_IND": { "notIn": ['1'] } },

            },
            dctIncludeBelongsToNamedRelations: {
                [esWB_Published_Model]: [esWB_Entity, esWB_Model]
            },
            dctExcludeHasManyNamedRelations: {
                [esWB_ScnPlanner]: [esWB_ScnPlannerCalc,  esWB_ScnPlannerTrial, esWB_ScnPlannerTrialEvt]
            }


        }

        const aRecResolver = new ESRecordResolver(dbContext, scope_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_ScnPlanner, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};

PAEnvironment.registerBusinessObjectClass(ScenarioPlannerBO, "ScenarioPlannerBO", "Scenario Planner")
